import Vue from "vue";
import "./plugins";
import App from "./App.vue";

import { sync } from "vuex-router-sync";
import router from "./router";
import { store } from "./store/index";
import i18n from "./plugins/i18n";

sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
